import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './breadcrumb-item.scss';

export default class BreadCrumbItem extends React.Component {
  static defaultProps = {
    item: PropTypes.object,
    color: PropTypes.string,
  };

  render() {
    const {
      item: { title, url, prevPage, search },
      color,
    } = this.props;

    return (
      <>
        {url ? (
          <Link
            to={{
              pathname: url,
              search: search ? search : '',
              state: {
                prevPage: prevPage ? prevPage : '',
                search: search ? search : '',
              },
            }}
            className={`breadcrumb-item ml-1 mr-1 ${
              color === 'red' ? '_red' : ''
            }`}
          >
            {title}
          </Link>
        ) : (
          <span className="breadcrumb-item ml-1 mr-1 _disabled color-gray-icon">
            {title}
          </span>
        )}
      </>
    );
  }
}
